var ctrlopt = ctrlopt;

(function ($) {
  var pCounterId,
    pAppointmentId,
    pToken,
    pStoreId,
    pVirtual,
    loc = window.parent.location !== window.location
      ? window.parent.location :
      window.location,
    nextSection = 'counters',
    apptBook = Drupal.appointmentBooking,
    modelSectionData = [
      {
        id: 'counters',
        jqElem: $('#counters')
      },
      {
        id: 'services',
        jqElem: $('#services')
      },
      {
        id: 'appointments',
        jqElem: $('#appointments')
      },
      {
        id: 'confirm',
        jqElem: $('#confirm')
      },
      {
        id: 'confirmation',
        jqElem: $('#confirmation')
      }
    ];

  Drupal.appointmentBooking.servicesCMSData = modelSectionData[1].jqElem.find('.service');

  function getURLParam(oTarget, sVar) {
    return decodeURI(
      oTarget.search.replace(
        new RegExp('^(?:.*[&\\?]' + encodeURI(sVar).replace(/[\.\+\*]/g, '\\$&') + '(?:\\=([^&]*))?)?.*$', 'i'),
        '$1'
      )
    );
  }

  pStoreId = getURLParam(loc, 'store_number');
  pCounterId = getURLParam(loc, 'counter_id');
  pServicdesId = getURLParam(loc, 'services_id');
  pAppointmentId = getURLParam(loc, 'appointment_id');
  pToken = getURLParam(loc, 'token');
  pVirtual = getURLParam(loc, 'virtual');

  Drupal.behaviors.apptBook = {
    attach: function () {
      var updateObj,
        updateParams = null,
        hasCounters = false,
        hasServices = false,
        container = $('#appointment-book-container'),
        sectionsContainer = $('#appointment-book-sections'),
        sections = sectionsContainer.find('.appt-book-section'),
        sectionManager = apptBook.sectionManager.init(sectionsContainer, sections),
        mData = { data: modelSectionData },
        self = this;

      $(window).load(function() {
        $('.appt-book-loader').addClass('hidden');
        $('.appt-book').removeClass('hidden');
      });

      if (pToken) {
        mData.token = pToken;
      }

      function setCounters(data) {
        if (!data || !data.length) {
          window.location = '/';

          return;
        }
        hasCounters = true;
        if (hasServices) {
          run();
        }
      }

      function setServices() {
        hasServices = true;
        if (hasCounters) {
          run();
        }
      }

      function run() {
        var currentSection, $header, $dots, $title, $subhead, $subheadVirtual, isMobile;

        sectionManager.setModel(apptBook.sectionModel).startObserving();
        apptBook.historyHandler.setModel(apptBook.sectionModel).startObserving();

        if (pStoreId) {
          var foundCounterByNumber = apptBook.sectionModel.countersData.filter(function (element) {
            return element.store_no === pStoreId;
          })[0];

          if (foundCounterByNumber) {
            pCounterId = foundCounterByNumber.id;
          }
        }

        if (pCounterId && pServicdesId) {
          nextSection = 'appointments';
          updateParams = {
            sectionId: nextSection,
            counterId: pCounterId,
            servicesId: pServicdesId.split(',')
          };
        } else if (pCounterId) {
          nextSection = 'services';
          updateParams = {
            sectionId: nextSection,
            counterId: pCounterId
          };
        }

        if (pAppointmentId) {
          nextSection = 'appointments';
          updateParams = {
            appointmentId: pAppointmentId
          };
        }

        if (pVirtual) {
          self.setVirtual('virtual_oab', 1);
        }

        updateObj = {
          sectionId: nextSection,
          params: updateParams
        };

        // Subscribe to sectionModel update events and update the page header and the page indication dots
        apptBook.sectionModel.on('update', function (data) {
          var config = Drupal.settings.appointment_booking_main_collection,
            section = data.sectionId;

          if (section === currentSection) {
            return;
          }

          $header = $('.appt-book-page-header');
          $dots = $('.appt-book-page-header-content__dots', $header);
          $title = $('.appt-book-page-header-content__title', $header);
          $subhead = $('.appt-book-page-header-content__subhead.physical_oab_content', $header);
          $subheadVirtual = $('.appt-book-page-header-content__subhead.virtual_oab_content', $header);
          // isMobile = Unison.fetch.now().name === 'small';
          isMobile = site.client.isMobile;

          if (isMobile) {
            $title = $('span', $title);
          }

          var s = {};

          for (var key in config) {
            if (!config.hasOwnProperty(key)) {
              continue;
            }

            s = config[key];
            if (s['section_key'] == section) {
              break;
            }
          }

          if (!$.isEmptyObject(s)) {
            $dots.show();

            var i = s['section_number'];

            if (i.length > 0) {
              $('li', $dots)
                .removeClass('active')
                .addClass('disabled')
                .filter('.dot--' + i)
                .addClass('active')
                .removeClass('disabled');
            } else {
              $('li', $dots).removeClass('active');
            }

            $title.html(s['section_title']);
            $subhead.html(s['section_subhead']);
            $subheadVirtual.html(s['section_subhead_virtual']);
          }

          currentSection = section;
        });

        apptBook.sectionModel.update(updateObj);
      }

      apptBook.sectionModel.on('data_set', function () {
        apptBook.sectionModel.off('data_set');
        apptBook.sectionModel.getCounters(setCounters);
        apptBook.sectionModel.getServices(setServices);
      });

      apptBook.sectionModel.setData(mData);
    },
    setVirtual: function (key, value) {
      localStorage.setItem(key, value);
    }
  };
})(jQuery);
